import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../reducers/reducer";
import FilesView from "../../views/DashboardView/SustainabilityView/FilesView";
import { setSelectedYear } from "../../reducers/exciseDuty/taxPeriods";
import { getFiles } from "../../reducers/sustainability/files";

interface Props {
  files: any;
  taxPeriods: any[];
  selectedYear: number;
  setSelectedYear: any;
  getFiles: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      files: state.sustainability.files.data,
      taxPeriods: state.exciseDuty.taxPeriods.data,
      selectedYear: state.exciseDuty.taxPeriods.selectedYear,
    }),
    (dispatch: any) => ({
      dispatch,
      setSelectedYear: (year: number) => dispatch(setSelectedYear(year)),
      getFiles: () => dispatch(getFiles()),
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {
      this.props.getFiles();
    },
  })
)(FilesView);
